"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotType = void 0;
var BotType;
(function (BotType) {
    BotType["LINKEDIN_RECRUITER_LITE"] = "linkedin_recruiter_lite";
    BotType["LINKEDIN_FREE_PROFILE"] = "linkedin_free_profile";
})(BotType = exports.BotType || (exports.BotType = {}));
